/* REDTEC · Compra rápida nos cards da página inicial (escolha de cor + adicionar ao carrinho) */
(function () {
  if (window.__rtQuickAdd) return;
  window.__rtQuickAdd = true;

  var ADD = 'Adicionar<span class="rt-hide-sm"> ao carrinho</span>';
  var money = function (cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  function data(card) {
    if (card.__v) return card.__v;
    try { card.__v = JSON.parse(card.querySelector('[data-rt-variants]').textContent); } catch (e) { card.__v = []; }
    return card.__v;
  }

  function selectColor(card, dot) {
    var group = dot.closest('[data-opt-index]');
    var idx = parseInt(group.getAttribute('data-opt-index'), 10);
    var value = dot.getAttribute('data-value');
    var list = data(card).filter(function (v) { return v.o[idx] === value; });
    var v = list.find(function (x) { return x.a; }) || list[0];
    if (!v) return;
    group.querySelectorAll('.rt-dot').forEach(function (d) { d.setAttribute('aria-checked', d === dot ? 'true' : 'false'); });
    var img = card.querySelector('.rt-pcard__media img');
    if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
    var price = card.querySelector('[data-rt-price]');
    if (price) price.innerHTML = (v.c > v.p ? '<s>' + money(v.c) + '</s>' : '') + '<strong>' + money(v.p) + '</strong>';
    var pix = card.querySelector('[data-rt-pix]');
    if (pix) { var R = window.RT_PAY || { pix: 10, max: 12, min: 3325 }; var n = Math.max(1, Math.min(R.max || 12, Math.floor(v.p / (R.min || 3325)))); pix.innerHTML = '<strong>' + money(Math.floor(v.p * (100 - R.pix) / 100)) + '</strong> no Pix (' + R.pix + '% off)' + (n > 1 ? ' · ou até ' + n + 'x de ' + money(Math.floor(v.p / n)) + ' sem juros' : ''); }
    var btn = card.querySelector('[data-rt-add]');
    if (btn) {
      btn.setAttribute('data-variant-id', v.id);
      btn.disabled = !v.a;
      btn.querySelector('[data-rt-add-label]').innerHTML = v.a ? ADD : 'Esgotado nesta cor';
    }
  }

  function openDrawer() {
    var sel = '.rt-cart-host cart-drawer-component';
    var d = document.querySelector(sel) || document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }

  function add(btn) {
    var id = btn.getAttribute('data-variant-id');
    var label = btn.querySelector('[data-rt-add-label]');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    label.textContent = 'Adicionando…';
    var sections = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) sections.push(c.dataset.sectionId); });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Erro');
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: {}, sourceId: String(id), data: { source: 'product-form-component', itemCount: 1, productId: btn.closest('[data-rt-card]').dataset.productId, sections: res.sections } }
        }));
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        label.textContent = 'Adicionado ✓';
        if (!openDrawer()) window.location.href = root + 'cart';
        setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; label.innerHTML = ADD; }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        label.textContent = 'Indisponível';
        setTimeout(function () { label.innerHTML = ADD; }, 3000);
        console.warn('[REDTEC] compra rápida:', err);
      });
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-rt-card] .rt-dot');
    if (dot) { e.preventDefault(); selectColor(dot.closest('[data-rt-card]'), dot); return; }
    var btn = e.target.closest('[data-rt-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });
})();
